module.exports = __webpack_public_path__ + "static/media/S1_00008.c22ca6be.jpg";